export const ACTIVITY_FREQUENCY_LABELS = Object.freeze({
  weekly: '週1回',
  biweekly: '月2回',
  monthly: '月1回',
  seasonal: '季節ごと',
  quarterly: '3ヶ月に1回',
  irregular: '不定期',
  other: 'その他'
});

export const AGE_GROUP_LABELS = Object.freeze({
  '20S': '20代',
  '30S': '30代',
  '40S': '40代',
  '50S': '50代',
  '60S': '60代以上',
  '20s': '20代',
  '30s': '30代',
  '40s': '40代',
  '50s': '50代',
  '60s': '60代以上',
  mixed: '幅広い年齢層'
});

export const ACTIVITY_STYLE_LABELS = Object.freeze({
  'beginner-friendly': '初心者歓迎',
  'fun-oriented': '楽しさ重視',
  'satoyama-focused': '里山中心',
  'hyakumeizan-focused': '百名山中心',
  'lightweight-oriented': '軽量志向',
  'senior-friendly': 'シニア向け',
  mixed: '様々なスタイル'
});

export function getActivityFrequencyLabel(value, otherValue = '') {
  if (!value) return '';
  if (value === 'other') return otherValue || ACTIVITY_FREQUENCY_LABELS.other;
  return ACTIVITY_FREQUENCY_LABELS[value] || otherValue || value;
}

export function getAgeGroupLabel(value) {
  if (!value) return '';
  return AGE_GROUP_LABELS[value] || value;
}

export function getActivityStyleLabel(value) {
  if (!value) return '';
  return ACTIVITY_STYLE_LABELS[value] || value;
}
